import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getAccessManagementGlobalSearch = async (municipality_id, params, token) => {
  const url = `municipalities/${municipality_id}/search`

  const data = await apiGet({ url, params, token })
  return data
}

export function useAccessManagementGlobalSearch({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getAccessManagementGlobalSearch(municipality_id, params, token)
  const queryKey = ['search', params]

  return useQuery(queryKey, queryFn, {
    keepPreviousData: true,
    ...options
  })
}
